var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M434.252 31.977l-21.409-21.416C405.424 3.521 396.759 0 386.868 0c-10.095 0-18.657 3.521-25.7 10.561L222.41 149.323 83.653 10.565C76.611 3.525 68.047.004 57.956.004c-9.896 0-18.559 3.521-25.979 10.561L10.849 31.981C3.615 39.21 0 47.873 0 57.962c0 10.277 3.619 18.842 10.848 25.693L196.712 269.52c6.855 7.23 15.416 10.848 25.697 10.848 10.088 0 18.75-3.617 25.977-10.848L434.251 83.655c7.043-7.044 10.567-15.608 10.567-25.693.001-9.901-3.523-18.559-10.566-25.985z","fillRule":"nonzero"}));
}

Chevron.defaultProps = {"viewBox":"0 0 445 281","fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","fill":"#fff"};

module.exports = Chevron;

Chevron.default = Chevron;
